export default "__VITE_ASSET__DQVDQtdT__"